/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Capability_Desk_DescriptionInputs */

const en_landing_capability_desk_description = /** @type {(inputs: Landing_Capability_Desk_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real-time market signals and research matched to the clients who need them most, so every high-conviction call reaches the right desk first.`)
};

/**
* | output |
* | --- |
* | "Real-time market signals and research matched to the clients who need them most, so every high-conviction call reaches the right desk first." |
*
* @param {Landing_Capability_Desk_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_capability_desk_description = /** @type {((inputs?: Landing_Capability_Desk_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Capability_Desk_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_capability_desk_description(inputs)
});